import _objectSpread from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

var handleFile = function handleFile(props) {
  var file = props.file,
      onChange = props.onChange,
      handleNewFile = props.handleNewFile;

  if (typeof onChange === 'function') {
    onChange(file);
  }

  handleNewFile(file);
};

export var openUploadDialog = function openUploadDialog(props) {
  var ref = props.ref;
  ref.current.click();
};
export var dropHandler = function dropHandler(props) {
  var event = props.event;
  event.preventDefault();
  var file = event.dataTransfer.items[0].getAsFile();
  handleFile(_objectSpread(_objectSpread({}, props), {}, {
    file: file
  }));
};
export var uploadInputHandler = function uploadInputHandler(props) {
  var event = props.event;
  event.preventDefault();
  var file = event.target.files[0];
  if (!file) return;
  handleFile(_objectSpread(_objectSpread({}, props), {}, {
    file: file
  }));
};
export var dragOverHandler = function dragOverHandler(e) {
  e.preventDefault();
};